export enum PlatformType {
    Web = 'web',
    ios = 'ios',
    Android = 'android'
}
